import React from 'react';
// import CompanyItem from "./CompanyItem";
import SectionsItem from "./SectionsItem";
import CompanyItem from "./CompanyItem";



const SelectSection = () => {
    return (
        <>
            <CompanyItem />
            <SectionsItem />
        </>
    );
};

export default SelectSection;